import { compact, difference } from 'lodash';
import { useSelector } from 'store/hooks';

type MissingScopes = {
    missingScopesInProtections: string[];
    missingProtectionsInScopes: string[];
};

/**
 * Get current scopes and protections from Redux and return scopes names that are
 * present in one of the two but not in the other.
 *
 * @returns the list of scopes names that are missing in protections or scopes
 */
const useGetMissingScopes = (): MissingScopes => {
    const currentScopesPerBind = useSelector(
        (vision) => vision.support.currentScopesPerBind,
    );
    const customProtectionsPerBind = useSelector(
        (vision) => vision.support.customProtectionsPerBind,
    );
    const currentScopeNames = compact(
        currentScopesPerBind?.scopes?.map((scope) => scope.name),
    );
    const currentScopeNamesInProtections = compact(
        customProtectionsPerBind?.protections?.map(
            (protection) => protection.scope,
        ),
    );
    const missingScopesInProtections = difference(
        currentScopeNames,
        currentScopeNamesInProtections,
    );
    const missingProtectionsInScopes = difference(
        currentScopeNamesInProtections,
        currentScopeNames,
    );

    return {
        missingScopesInProtections,
        missingProtectionsInScopes,
    };
};

export default useGetMissingScopes;
